import { useState, useEffect } from 'react';
import { createClient } from 'contentful';

const client = createClient({
    space: process.env.GATSBY_CONTENTFUL_SPACE,
    accessToken: process.env.GATSBY_CONTENTFUL_ACCESS_TOKEN,
    environment: 'master', 
});

const useContentfulAwards = () => {
    const [images, setImages] = useState([]);

    useEffect(() => {
        client.getEntries({
            content_type: 'awards',
            order: '-sys.createdAt',
            limit: 12
        })
        .then((response) => {
            const fetchedImages = response.items.map(item => {
                return [
                    'https:' + item.fields.awardImage1.fields.file.url,
                    'https:' + item.fields.awardImage2.fields.file.url,
                    'https:' + item.fields.awardImage3.fields.file.url,
                    'https:' + item.fields.awardImage4.fields.file.url,
                    'https:' + item.fields.awardImage5.fields.file.url,
                    'https:' + item.fields.awardImage6.fields.file.url,
                    'https:' + item.fields.awardImage7.fields.file.url,
                    'https:' + item.fields.awardImage8.fields.file.url,
                    'https:' + item.fields.awardImage9.fields.file.url,
                    'https:' + item.fields.awardImage10.fields.file.url,
                ];
            });
            setImages(fetchedImages.flat());
        })
        .catch(console.error);
    }, []);

    return images;
};
export default useContentfulAwards;